/* Quick Shop enhancements:
   - initializes Swiper gallery after dynamic Quick Shop load
   - fetches product-tabs section
   - initializes GX desktop tabs
   - initializes GX mobile accordion
*/

(function () {
  'use strict';

  var PRODUCT_WRAPPER_SELECTOR = '[data-product-wrapper]';
  var STATIC_PRODUCT_SELECTOR = '[data-section-type="static-product"]';

  var TABS_SECTION_ID = 'product-tabs';

  var quickshopInitTimer = null;


  /* =========================================================
     QUICKSHOP HELPERS
     ========================================================= */

  function getQuickshopModal() {
    return document.querySelector(
      '.modal.modal--quickshop-full'
    );
  }


  function getModalContent() {
    var modal = getQuickshopModal();

    if (!modal) {
      return null;
    }

    return modal.querySelector(
      '[data-modal-content]'
    );
  }


  function getTabsContainer() {
    var modal = getQuickshopModal();

    if (!modal) {
      return null;
    }

    return (
      modal.querySelector(
        '.kg-modal-content[kg-data-modal]'
      ) ||
      modal.querySelector(
        '.kg-modal-content'
      )
    );
  }


  function parseProductSettings(modalContent) {
    if (!modalContent) {
      return null;
    }

    var scriptEl =
      modalContent.querySelector(
        STATIC_PRODUCT_SELECTOR
      );

    if (!scriptEl) {
      return null;
    }

    try {
      return JSON.parse(
        scriptEl.textContent ||
        scriptEl.innerHTML ||
        '{}'
      );
    } catch (error) {
      console.warn(
        'Quickshop: Produkt-Einstellungen konnten nicht gelesen werden.',
        error
      );

      return null;
    }
  }


  /* =========================================================
     SWIPER
     ========================================================= */

  function initQuickshopSwiper(scopeEl) {
    if (!scopeEl) {
      return;
    }

    if (typeof Swiper === 'undefined') {
      return;
    }


    var thumbsEl =
      scopeEl.querySelector(
        '.product-gallery--thumb-swiper'
      );

    var mainEl =
      scopeEl.querySelector(
        '.product-gallery--main-swiper'
      );


    if (!thumbsEl || !mainEl) {
      return;
    }


    /*
      Falls bereits initialisiert:
      keine zweite Swiper-Instanz erzeugen.
    */
    if (
      mainEl.swiper ||
      thumbsEl.swiper
    ) {
      return;
    }


    var thumbSlides =
      thumbsEl.querySelectorAll(
        '.swiper-slide'
      );

    var mainSlides =
      mainEl.querySelectorAll(
        '.swiper-slide'
      );


    /*
      Empire hat das Galerie-Markup
      noch nicht vollständig eingesetzt.
    */
    if (
      !thumbSlides.length ||
      !mainSlides.length
    ) {
      return;
    }


    var thumbsSwiper =
      new Swiper(
        thumbsEl,
        {
          slidesPerView: 5,

          spaceBetween: 8,

          watchSlidesProgress: true,

          watchOverflow: true,

          navigation: {
            nextEl:
              thumbsEl.querySelector(
                '.swiper-button-next'
              ),

            prevEl:
              thumbsEl.querySelector(
                '.swiper-button-prev'
              )
          },

          breakpoints: {
            0: {
              slidesPerView: 4,
              spaceBetween: 6
            },

            480: {
              slidesPerView: 5,
              spaceBetween: 8
            }
          }
        }
      );


    new Swiper(
      mainEl,
      {
        slidesPerView: 1,

        spaceBetween: 0,

        watchOverflow: true,

        navigation: {
          nextEl:
            mainEl.querySelector(
              '.swiper-button-next'
            ),

          prevEl:
            mainEl.querySelector(
              '.swiper-button-prev'
            )
        },

        thumbs: {
          swiper: thumbsSwiper
        }
      }
    );
  }


  /* =========================================================
     GX DESKTOP TABS
     ========================================================= */

  function initDesktopTabs(scopeEl) {
    if (!scopeEl) {
      return;
    }


    var wrapper =
      scopeEl.querySelector(
        '.gx-product-tabs-wrapper'
      );


    if (!wrapper) {
      return;
    }


    /*
      Keine Event Listener doppelt setzen.
    */
    if (
      wrapper.dataset.kgTabsInitialized ===
      'true'
    ) {
      return;
    }


    var tabs =
      wrapper.querySelectorAll(
        '.gx-desktop-tabs .gx-tab-item'
      );

    var panels =
      wrapper.querySelectorAll(
        '.gx-desktop-tabs .gx-tab-panel'
      );


    if (
      !tabs.length ||
      !panels.length
    ) {
      return;
    }


    wrapper.dataset.kgTabsInitialized =
      'true';


    function activateTab(tab) {
      tabs.forEach(function (item) {
        item.classList.remove(
          'is-active'
        );

        item.setAttribute(
          'aria-selected',
          'false'
        );

        item.setAttribute(
          'tabindex',
          '-1'
        );
      });


      panels.forEach(function (panel) {
        panel.classList.remove(
          'is-active'
        );
      });


      tab.classList.add(
        'is-active'
      );


      tab.setAttribute(
        'aria-selected',
        'true'
      );


      tab.setAttribute(
        'tabindex',
        '0'
      );


      var target =
        tab.getAttribute(
          'data-tab'
        );


      if (!target) {
        return;
      }


      var panel =
        wrapper.querySelector(
          '#' +
          CSS.escape(target)
        );


      if (panel) {
        panel.classList.add(
          'is-active'
        );
      }
    }


    tabs.forEach(function (tab) {
      tab.addEventListener(
        'click',
        function (event) {
          event.preventDefault();

          activateTab(tab);
        }
      );


      tab.addEventListener(
        'keydown',
        function (event) {
          var tabArray =
            Array.prototype.slice.call(
              tabs
            );


          var index =
            tabArray.indexOf(
              tab
            );


          var nextTab = null;


          if (
            event.key ===
            'ArrowRight'
          ) {
            event.preventDefault();

            nextTab =
              tabArray[
                (
                  index +
                  1
                ) %
                tabArray.length
              ];
          }


          if (
            event.key ===
            'ArrowLeft'
          ) {
            event.preventDefault();

            nextTab =
              tabArray[
                (
                  index -
                  1 +
                  tabArray.length
                ) %
                tabArray.length
              ];
          }


          if (nextTab) {
            nextTab.focus();

            activateTab(
              nextTab
            );
          }
        }
      );
    });
  }


  /* =========================================================
     MOBILE ACCORDION
     ========================================================= */

  function initMobileAccordion(scopeEl) {
    if (!scopeEl) {
      return;
    }


    var wrapper =
      scopeEl.querySelector(
        '.gx-product-tabs-wrapper'
      );


    if (!wrapper) {
      return;
    }


    var accordion =
      wrapper.querySelector(
        '.gx-mobile-accordion'
      );


    if (!accordion) {
      return;
    }


    if (
      accordion.dataset
        .kgAccordionInitialized ===
      'true'
    ) {
      return;
    }


    var triggers =
      accordion.querySelectorAll(
        '.gx-accordion-trigger'
      );


    if (!triggers.length) {
      return;
    }


    accordion.dataset
      .kgAccordionInitialized =
      'true';


    triggers.forEach(
      function (trigger) {
        trigger.addEventListener(
          'click',
          function (event) {
            event.preventDefault();


            var target =
              trigger.getAttribute(
                'data-accordion'
              );


            if (!target) {
              return;
            }


            var panel =
              wrapper.querySelector(
                '#' +
                CSS.escape(target)
              );


            if (!panel) {
              return;
            }


            var isOpen =
              trigger.classList
                .contains(
                  'is-active'
                );


            if (isOpen) {
              trigger.classList.remove(
                'is-active'
              );

              trigger.setAttribute(
                'aria-expanded',
                'false'
              );

              panel.classList.remove(
                'is-open'
              );
            } else {
              trigger.classList.add(
                'is-active'
              );

              trigger.setAttribute(
                'aria-expanded',
                'true'
              );

              panel.classList.add(
                'is-open'
              );
            }
          }
        );
      }
    );
  }


  /* =========================================================
     PRODUCT TABS FETCH
     ========================================================= */

  function appendTabsIfMissing(html) {
    if (!html) {
      return;
    }


    var target =
      getTabsContainer();


    if (!target) {
      return;
    }


    /*
      Falls Tabs bereits vorhanden:
      nur Interaktionen initialisieren.
    */
    var existing =
      target.querySelector(
        '.gx-product-tabs-wrapper'
      );


    if (existing) {
      initDesktopTabs(
        target
      );

      initMobileAccordion(
        target
      );

      return;
    }


    var temp =
      document.createElement(
        'div'
      );


    temp.innerHTML =
      html;


    var sectionEl =
      temp.querySelector(
        '#shopify-section-' +
        TABS_SECTION_ID
      );


    /*
      Fallback auf Section-Class.
    */
    if (!sectionEl) {
      sectionEl =
        temp.querySelector(
          '.kg-product-tab'
        );
    }


    if (!sectionEl) {
      console.warn(
        'Quickshop: Produkt-Tabs wurden nicht gefunden.'
      );

      return;
    }


    /*
      Alten Tab-Inhalt entfernen,
      anschließend aktuelle Section einsetzen.
    */
    target.innerHTML =
      '';


    target.appendChild(
      sectionEl
    );


    initDesktopTabs(
      target
    );


    initMobileAccordion(
      target
    );
  }


  function fetchAndInjectTabs(
    modalContent,
    handle
  ) {
    if (!handle) {
      return;
    }


    var tabsTarget =
      getTabsContainer();


    /*
      Bereits geladen?
    */
    if (
      tabsTarget &&
      tabsTarget.querySelector(
        '.gx-product-tabs-wrapper'
      )
    ) {
      initDesktopTabs(
        tabsTarget
      );

      initMobileAccordion(
        tabsTarget
      );

      return;
    }


    var url =
      '/products/' +
      encodeURIComponent(
        handle
      ) +
      '?section_id=' +
      encodeURIComponent(
        TABS_SECTION_ID
      );


    fetch(url)

      .then(
        function (response) {
          if (!response.ok) {
            throw new Error(
              'Produkt-Tabs konnten nicht geladen werden.'
            );
          }

          return response.text();
        }
      )

      .then(
        function (html) {
          appendTabsIfMissing(
            html
          );
        }
      )

      .catch(
        function (error) {
          console.warn(
            'Quickshop Tabs:',
            error
          );
        }
      );
  }


  /* =========================================================
     QUICKSHOP INITIALIZATION
     ========================================================= */

  function initializeQuickshop() {
    var modal =
      getQuickshopModal();


    if (!modal) {
      return;
    }


    var modalContent =
      getModalContent();


    if (!modalContent) {
      return;
    }


    var productWrapper =
      modalContent.querySelector(
        PRODUCT_WRAPPER_SELECTOR
      );


    /*
      Empire hat das Produkt
      noch nicht eingesetzt.
    */
    if (!productWrapper) {
      return;
    }


    /*
      Galerie initialisieren.
    */
    initQuickshopSwiper(
      modalContent
    );


    /*
      Produkt-Settings lesen.
    */
    var settings =
      parseProductSettings(
        modalContent
      );


    var handle =
      settings &&
      settings.product &&
      settings.product.handle;


    /*
      Tabs laden.
    */
    if (handle) {
      fetchAndInjectTabs(
        modalContent,
        handle
      );
    }
  }


  /* =========================================================
     ROBUSTER QUICKSHOP START
     ========================================================= */

  function scheduleQuickshopInit() {
    /*
      Laufenden Versuch zunächst stoppen.
    */
    if (quickshopInitTimer) {
      clearInterval(
        quickshopInitTimer
      );
    }


    var attempts = 0;


    quickshopInitTimer =
      setInterval(
        function () {
          attempts++;


          var modal =
            getQuickshopModal();


          var mainSwiper =
            modal
              ? modal.querySelector(
                  '.product-gallery--main-swiper'
                )
              : null;


          var thumbSwiper =
            modal
              ? modal.querySelector(
                  '.product-gallery--thumb-swiper'
                )
              : null;


          /*
            Empire hat das komplette
            Swiper-Markup eingesetzt.
          */
          if (
            modal &&
            mainSwiper &&
            thumbSwiper &&
            mainSwiper
              .querySelectorAll(
                '.swiper-slide'
              )
              .length &&
            thumbSwiper
              .querySelectorAll(
                '.swiper-slide'
              )
              .length
          ) {
            initializeQuickshop();


            /*
              Erfolgreich initialisiert.
            */
            if (
              mainSwiper.swiper
            ) {
              clearInterval(
                quickshopInitTimer
              );

              quickshopInitTimer =
                null;
            }
          }


          /*
            Nach ca. 5 Sekunden abbrechen.
          */
          if (
            attempts >= 50
          ) {
            clearInterval(
              quickshopInitTimer
            );

            quickshopInitTimer =
              null;
          }
        },
        100
      );
  }


  /* =========================================================
     QUICKSHOP CLICK
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {
      var button =
        event.target.closest(
          '.quickshop-button'
        );


      if (!button) {
        return;
      }


      scheduleQuickshopInit();
    }
  );


  /* =========================================================
     MUTATION OBSERVER

     Empire setzt Quickshop-Inhalte
     dynamisch in das DOM.
     ========================================================= */

  var observer =
    new MutationObserver(
      function () {
        var modal =
          getQuickshopModal();


        if (!modal) {
          return;
        }


        var mainSwiper =
          modal.querySelector(
            '.product-gallery--main-swiper'
          );


        /*
          Quickshop vorhanden,
          aber Galerie noch nicht initialisiert.
        */
        if (
          mainSwiper &&
          !mainSwiper.swiper
        ) {
          scheduleQuickshopInit();
        }


        /*
          Falls Tabs bereits eingesetzt wurden,
          aber ihre Inline-Scripts nicht ausgeführt wurden.
        */
        var tabsTarget =
          getTabsContainer();


        if (
          tabsTarget &&
          tabsTarget.querySelector(
            '.gx-product-tabs-wrapper'
          )
        ) {
          initDesktopTabs(
            tabsTarget
          );

          initMobileAccordion(
            tabsTarget
          );
        }
      }
    );


  /* =========================================================
     START
     ========================================================= */

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      if (!document.body) {
        return;
      }


      observer.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );


      /*
        Falls Quickshop bereits vorhanden ist.
      */
      initializeQuickshop();
    }
  );

})();